module.exports = __webpack_public_path__ + "img/user.3c17f900.jpg";